import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { AccueilPage as SommeilBlignyAccueilPage } from '@/pages/onboarding/sommeil-bligny/AccueilPage';

export const LandingSommeilBligny = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return <SommeilBlignyAccueilPage onNext={navigateNext} />;
};
